// Sentry must be imported and initialized first — before React or app code.
import "./instrument";

// i18n: initialize before React renders so first paint has correct language
import "./i18n";

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
